'use client';

import { c as _c } from "react/compiler-runtime";
import { NexperienceDayPricesDocument } from '@data-access/lib/gql/experience/documents';
import { useGraphQL } from '@data-access/lib/graphql-query';
import { keepPreviousData } from '@tanstack/react-query';
import { DAY_PRICE_ERROR_REPORT } from '../../_lib/report-terminal-day-price-error';
export const EXPERIENCE_DAY_PRICES_STALE_TIME = 5 * 60 * 1000;
export type { ExperienceDayPrice, ExperienceDayPrices } from '../_lib/day-prices';
import { toDayPrices } from '../_lib/day-prices';
export function useAppExperienceDayPrices(experienceId, from, to) {
  const $ = _c(14);
  const enabled = !!experienceId && !!from && !!to;
  const t0 = from ?? "";
  const t1 = to ?? "";
  let t2;
  if ($[0] !== experienceId || $[1] !== t0 || $[2] !== t1) {
    t2 = {
      experienceId,
      from: t0,
      to: t1
    };
    $[0] = experienceId;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      terminalErrorReport: DAY_PRICE_ERROR_REPORT
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== enabled) {
    t4 = {
      enabled,
      meta: t3,
      placeholderData: keepPreviousData,
      staleTime: EXPERIENCE_DAY_PRICES_STALE_TIME,
      select: toDayPrices
    };
    $[5] = enabled;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data,
    isLoading,
    isPlaceholderData,
    isError,
    isFetching,
    refetch,
    errorUpdatedAt,
    dataUpdatedAt
  } = useGraphQL(NexperienceDayPricesDocument, t2, t4);
  const t5 = isError || isFetching && errorUpdatedAt > dataUpdatedAt;
  const t6 = enabled && (isLoading || isPlaceholderData);
  let t7;
  if ($[7] !== data || $[8] !== isFetching || $[9] !== isLoading || $[10] !== refetch || $[11] !== t5 || $[12] !== t6) {
    t7 = {
      dayPrices: data,
      isLoading,
      isError: t5,
      isFetching,
      refetch,
      arePreliminary: t6
    };
    $[7] = data;
    $[8] = isFetching;
    $[9] = isLoading;
    $[10] = refetch;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}